// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto'// axios IE support
import 'babel-polyfill'// es6 IE support
import 'intersection-observer' // Optional
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuelidate from 'vuelidate'
import { store } from './store/store'
import Paginate from 'vuejs-paginate'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import 'fullpage.js/vendors/scrolloverflow'
import 'fullpage.js/dist/fullpage.min.css'
import VueFullPage from 'vue-fullpage.js'
import VueFileAgent from 'vue-file-agent'
import 'vue-file-agent/dist/vue-file-agent.css'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
// import 'quill/dist/quill.bubble.css'  for bubble theme
import uiControl from './assets/js/ui.control'
import VueAutosuggest from 'vue-autosuggest'
import VueImg from 'v-img'
Vue.use(VueImg)
Vue.use(VueAutosuggest)
Vue.use(VueQuillEditor)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueFileAgent)
Vue.use(VueFullPage)
library.add(faPlus)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('paginate', Paginate)
Vue.use(Vuelidate)
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper)
let filter = function (text, length, clamp) {
  clamp = clamp || '...'
  let node = document.createElement('div')
  node.innerHTML = text
  let content = node.textContent
  return content.length > length ? content.slice(0, length) + clamp : content
}
Vue.filter('truncate', filter)
Vue.use(uiControl)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js